module.exports = __webpack_public_path__ + "media/images/squadBet__iconPick-76f9c081481578d4283ae1aabdaf44f5.png";